import type { QueryClient } from '@tanstack/react-query';

import type { ValidatingHttpFetcherWithBaseUrl } from '../validating-http-fetcher';
import type { FeatureFlagService } from './feature-flag-service';
import { createPrivacyProxyFeatureFlagService } from './privacy-proxy';

type FeatureFlagServiceOptions = {
    readonly queryClient: QueryClient;
    readonly validatingRealtimeApiFetcher: ValidatingHttpFetcherWithBaseUrl;
};

export const createFeatureFlagService = (options: FeatureFlagServiceOptions): FeatureFlagService =>
    createPrivacyProxyFeatureFlagService(options);
